const rejectHandler = reason => ({ status: 'rejected', reason });
const resolveHandler = value => ({ status: 'fulfilled', value });

const polyfillPromiseAllSettled = () => {
  if (Promise.allSettled) return;

  Promise.allSettled = function (promises) {
    const convertedPromises = promises.map(
      p => Promise.resolve(p).then(resolveHandler, rejectHandler),
    );
    return Promise.all(convertedPromises);
  };
};

const logErrorResults = (resultsArr, logLabelText) => {
  const labelText = typeof logLabelText === 'string' && logLabelText ? logLabelText : '';
  resultsArr.forEach((result) => {
    if (result.status === 'rejected') {
      console.log(labelText, result.reason);
    } else if (result.status === 'fulfilled' && result.value && result.value.error) {
      console.log(labelText, result.value.error);
    }
  });
};

export {
  polyfillPromiseAllSettled,
  logErrorResults,
};
